import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter } from 'rxjs';

@Component({
    standalone: true,
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    imports: [CommonModule, BreadcrumbModule, MatTooltipModule]
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() tooltip: string;
  @Input() header: string;

  @Input() description: string;
  @Input() showBreadcrumb=true;
  items: MenuItem[] = [];
@Input() breadcrumb: MenuItem[] | null = null; // <-- Add this line

  constructor(private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,) {
  }

  ngOnInit(): void {
     if (this.breadcrumb && this.breadcrumb.length > 0) {
      this.items = this.breadcrumb;
    } else {this.items = this.manageBreadBrumbs();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.items = this.manageBreadBrumbs());
      if(!this.tooltip){
        this.tooltip=this.header;
      }
    }
  }
  manageBreadBrumbs(): MenuItem[]{
     const breadCrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      if (breadCrumbs.length > 0) {
       breadCrumbs[breadCrumbs.length - 1].styleClass = 'active';
       breadCrumbs[breadCrumbs.length - 1].command = () => {
          this.router.navigateByUrl(this.router.url);
        };
      }
      return breadCrumbs;
  }
  private createBreadcrumbs(route: ActivatedRoute, url: string = '#', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const child = route.firstChild ?? route.children[0];
    if (!child) {
      return breadcrumbs;
    }

    const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
    if (routeURL !== '') {
      url += `/${routeURL}`;
    }

    const label = child.snapshot.data['breadcrumb'];
    if (label) {
      breadcrumbs.push({ label, command: () => {
        this.router.navigateByUrl(url);
      }});
    }

    return this.createBreadcrumbs(child, url, breadcrumbs);
  }
}
